<nav class="navbar navbar-expand-xl navbar-light fixed-top">
  <div class="container-fluid align-items-start align-items-lg-center">
    <a class="navbar-brand d-xl-none" href="index.html"
      ><img src="./assets/img/logo.png" class="logoMobile"
    /></a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarCollapse"
      aria-controls="navbarCollapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav mx-auto d-flex align-items-start">
        <li class="nav-item">
          <a class="nav-link mod" href="#inicio">{{ texto.menu.inicio }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link mod" href="#tradicao">{{ texto.menu.tradicao }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link mod" href="#esporte">{{ texto.menu.oesporte }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link mod" href="#equipamentos">{{
            texto.menu.equipamentos
          }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link mod" href="#arena">{{ texto.menu.aarena }}</a>
        </li>
        <li>
          <a class="d-none d-lg-block logo external" href="index.html"
            ><img src="./assets/img/logo.png"
          /></a>
        </li>

        <li class="nav-item">
          <a class="nav-link mod" href="#atletas">{{ texto.menu.osatletas }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link mod" href="#animais">{{ texto.menu.osanimais }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link mod" href="#fotos">{{ texto.menu.fotos }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link mod" href="#imprensa">{{
            texto.menu.imprensa
          }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link mod" href="#contato">{{ texto.menu.contato }}</a>
        </li>
        <li class="nav-item dropdown idioma">
          <a
            class="nav-link dropdown-toggle idiomas"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img src="./assets/img/{{ idioma }}.png" alt="" />
          </a>

          <ul class="dropdown-menu idiomas">
            <li>
              <a
                href="#"
                class="dropdown-item mod external"
                (click)="trocarIdioma('pt')"
              >
                <img src="./assets/img/pt.png" alt="" /> PT
              </a>
            </li>
            <li>
              <a
                href="#"
                class="dropdown-item mod external"
                (click)="trocarIdioma('en')"
              >
                <img src="./assets/img/en.png" alt="" /> EN</a
              >
            </li>
            <li>
              <a
                href="#"
                class="dropdown-item mod external"
                (click)="trocarIdioma('fr')"
              >
                <img src="./assets/img/fr.png" alt="" /> FR</a
              >
            </li>
            <li>
              <a
                href="#"
                class="dropdown-item mod external"
                (click)="trocarIdioma('it')"
              >
                <img src="./assets/img/it.png" alt="" /> IT</a
              >
            </li>
            <li>
              <a
                href="#"
                class="dropdown-item mod external"
                (click)="trocarIdioma('es')"
              >
                <img src="./assets/img/es.png" alt="" /> ES</a
              >
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>

<div class="sobre" id="inicio">
  <div class="corrida">
    <div class="mt-4 d-flex align-items-center justify-content-center pdf">
      <a
        [href]="'./assets/pdfs/' + texto.arquivo"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="./assets/img/pdf.png" alt="Quadrigas"
      /></a>
      <div class="texto">
        <h3>{{ texto.pdf }}</h3>
        <a
          [href]="'./assets/pdfs/' + texto.arquivo"
          target="_blank"
          rel="noopener noreferrer"
          >{{ texto.linkPdf }}</a
        >
      </div>
    </div>
  </div>
</div>

<div class="texto"></div>

<div class="container my-5" id="tradicao">
  <div class="row d-flex align-items-center">
    <div class="col-md-8">
      <div class="mb-5">
        <h2 class="titulo">{{ texto.titulo }}</h2>
        <p class="justify">
          {{ texto.frase }}
        </p>
      </div>
      <h2 class="titulo">{{ texto.tradicao.titulo }}</h2>
      <div class="justify" [innerHTML]="texto.tradicao.texto"></div>
    </div>
    <div class="col-md-4">
      <img
        src="./assets/img/img_tradicao.jpeg"
        alt="Tradicao"
        class="img-fluid tradicao imagem"
      />
    </div>
  </div>
</div>

<div class="esporte" id="esporte">
  <div class="container">
    <h2 class="titulo">{{ texto.oesporte.titulo }}</h2>
    <div class="justify" [innerHTML]="texto.oesporte.texto"></div>
  </div>
</div>

<div class="equipamentos" id="equipamentos">
  <div class="back"></div>
  <div class="container">
    <h2 class="titulo">{{ texto.equipamentos.titulo }}</h2>
    <div class="grid">
      <div class="item" *ngFor="let equi of texto.equipamentos.itens">
        <h5>{{ equi.titulo }}</h5>
        <img
          [src]="'./assets/img/equipamentos/' + equi.img + '.png'"
          alt="Equipamento"
        />
        <p>{{ equi.texto }}</p>
      </div>
    </div>
  </div>
</div>
<div class="arena" id="arena">
  <div class="container">
    <h2 class="titulo">{{ texto.aarena.titulo }}</h2>
    <div class="justify" [innerHTML]="texto.aarena.texto"></div>
    <img
      src="./assets/img/arena_quadrigas_geral.jpeg"
      class="imagem img-fluid"
      alt=""
    />
  </div>
</div>
<div class="atletas" id="atletas">
  <div class="container">
    <h2 class="titulo">{{ texto.osatletas.titulo }}</h2>
    <div class="justify" [innerHTML]="texto.osatletas.texto"></div>
    <img src="./assets/img/img_atletas.jpg" class="imagem img-fluid" alt="" />
  </div>
</div>
<div class="animais" id="animais">
  <div class="container">
    <h2 class="titulo">{{ texto.osanimais.titulo }}</h2>
    <div class="justify" [innerHTML]="texto.osanimais.texto"></div>
    <img src="./assets/img/cavalos.jpeg" class="img-fluid cavalo" alt="" />
  </div>
</div>

<div class="fotos" id="fotos">
  <div class="container">
    <h2 class="titulo">{{ texto.fotos.titulo }}</h2>
    <div id="Galeria">
      <ul>
        <li>
          <a href="./assets/img/fotos/gal_001_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_001_g.jpg" alt="Foto 1"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_002_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_002_g.jpg" alt="Foto 2"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_003_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_003_g.jpg" alt="Foto 3"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_004_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_004_g.jpg" alt="Foto 4"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_005_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_005_g.jpg" alt="Foto 5"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_006_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_006_g.jpg" alt="Foto 6"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_007_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_007_g.jpg" alt="Foto 7"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_008_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_008_g.jpg" alt="Foto 8"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_009_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_009_g.jpg" alt="Foto 9"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_010_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_010_g.jpg" alt="Foto 10"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_011_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_011_g.jpg" alt="Foto 11"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_012_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_012_g.jpg" alt="Foto 12"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_013_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_013_g.jpg" alt="Foto 13"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_014_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_014_g.jpg" alt="Foto 14"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_015_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_015_g.jpg" alt="Foto 15"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_016_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_016_g.jpg" alt="Foto 16"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_017_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_017_g.jpg" alt="Foto 17"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_018_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_018_g.jpg" alt="Foto 18"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_019_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_019_g.jpg" alt="Foto 19"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_020_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_020_g.jpg" alt="Foto 20"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_021_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_021_g.jpg" alt="Foto 21"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_022_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_022_g.jpg" alt="Foto 22"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_023_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_023_g.jpg" alt="Foto 23"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_024_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_024_g.jpg" alt="Foto 24"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_025_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_025_g.jpg" alt="Foto 25"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_026_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_026_g.jpg" alt="Foto 26"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_027_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_027_g.jpg" alt="Foto 27"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_028_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_028_g.jpg" alt="Foto 28"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_029_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_029_g.jpg" alt="Foto 29"
          /></a>
        </li>
        <li>
          <a href="./assets/img/fotos/gal_030_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_030_g.jpg" alt="Foto 30"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_031_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_031_g.jpg" alt="Foto 31"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_032_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_032_g.jpg" alt="Foto 32"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_033_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_033_g.jpg" alt="Foto 33"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_034_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_034_g.jpg" alt="Foto 34"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_035_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_035_g.jpg" alt="Foto 35"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_036_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_036_g.jpg" alt="Foto 36"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_037_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_037_g.jpg" alt="Foto 37"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_038_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_038_g.jpg" alt="Foto 38"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_039_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_039_g.jpg" alt="Foto 39"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_040_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_040_g.jpg" alt="Foto 40"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_041_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_041_g.jpg" alt="Foto 41"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_042_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_042_g.jpg" alt="Foto 42"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_043_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_043_g.jpg" alt="Foto 43"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_044_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_044_g.jpg" alt="Foto 44"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_045_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_045_g.jpg" alt="Foto 45"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_046_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_046_g.jpg" alt="Foto 46"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_047_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_047_g.jpg" alt="Foto 47"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_048_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_048_g.jpg" alt="Foto 48"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_049_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_049_g.jpg" alt="Foto 49"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_050_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_050_g.jpg" alt="Foto 50"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_051_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_051_g.jpg" alt="Foto 51"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_052_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_052_g.jpg" alt="Foto 52"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_053_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_053_g.jpg" alt="Foto 53"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_054_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_054_g.jpg" alt="Foto 54"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_055_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_055_g.jpg" alt="Foto 55"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_056_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_056_g.jpg" alt="Foto 56"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_057_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_057_g.jpg" alt="Foto 57"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_058_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_058_g.jpg" alt="Foto 58"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_059_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_059_g.jpg" alt="Foto 59"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_060_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_060_g.jpg" alt="Foto 60"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_061_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_061_g.jpg" alt="Foto 61"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_062_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_062_g.jpg" alt="Foto 62"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_063_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_063_g.jpg" alt="Foto 63"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_064_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_064_g.jpg" alt="Foto 64"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_065_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_065_g.jpg" alt="Foto 65"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_066_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_066_g.jpg" alt="Foto 66"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_067_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_067_g.jpg" alt="Foto 67"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_068_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_068_g.jpg" alt="Foto 68"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_069_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_069_g.jpg" alt="Foto 69"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_070_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_070_g.jpg" alt="Foto 70"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_071_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_071_g.jpg" alt="Foto 71"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_072_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_072_g.jpg" alt="Foto 72"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_073_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_073_g.jpg" alt="Foto 73"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_074_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_074_g.jpg" alt="Foto 74"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_075_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_075_g.jpg" alt="Foto 75"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_076_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_076_g.jpg" alt="Foto 76"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_077_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_077_g.jpg" alt="Foto 77"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_078_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_078_g.jpg" alt="Foto 78"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_079_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_079_g.jpg" alt="Foto 79"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_080_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_080_g.jpg" alt="Foto 80"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_081_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_081_g.jpg" alt="Foto 81"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_082_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_082_g.jpg" alt="Foto 82"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_083_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_083_g.jpg" alt="Foto 83"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_084_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_084_g.jpg" alt="Foto 84"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_085_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_085_g.jpg" alt="Foto 85"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_086_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_086_g.jpg" alt="Foto 86"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_087_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_087_g.jpg" alt="Foto 87"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_088_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_088_g.jpg" alt="Foto 88"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_089_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_089_g.jpg" alt="Foto 89"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_090_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_090_g.jpg" alt="Foto 90"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_091_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_091_g.jpg" alt="Foto 91"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_092_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_092_g.jpg" alt="Foto 92"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_093_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_093_g.jpg" alt="Foto 93"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_094_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_094_g.jpg" alt="Foto 94"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_095_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_095_g.jpg" alt="Foto 95"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_096_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_096_g.jpg" alt="Foto 96"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_097_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_097_g.jpg" alt="Foto 97"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_098_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_098_g.jpg" alt="Foto 98"
          /></a>
        </li>

        <li>
          <a href="./assets/img/fotos/gal_099_g.jpg" data-fancybox="gal"
            ><img src="./assets/img/fotos/thumbs/gal_099_g.jpg" alt="Foto 99"
          /></a>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="imprensa" id="imprensa">
  <div class="container">
    <h2 class="titulo">{{ texto.imprensa.titulo }}</h2>
    <p>{{ texto.imprensa.texto }}</p>
    <div class="videos row">
      <div class="col-md-4 mb-4">
        <div class="ratio ratio-4x3">
          <iframe
            src="https://www.youtube.com/embed/I18sST2Gh8E"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-4 mb-4">
        <div class="ratio ratio-4x3">
          <iframe
            src="https://www.youtube.com/embed/bQfRY68WVjM"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-4 mb-4">
        <div class="ratio ratio-4x3">
          <iframe
            src="https://www.youtube.com/embed/0l8Gjw-yTTM"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-4 mb-4">
        <div class="ratio ratio-4x3">
          <iframe src="https://www.youtube.com/embed/S6trfrrbqu0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </div>
      <div class="col-md-4 mb-4">
        <div class="ratio ratio-4x3">
          <iframe src="https://www.youtube.com/embed/mK6-IRHaCVw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </div>
      <div class="col-md-4 mb-4">
        <div class="ratio ratio-4x3">
          <iframe src="https://www.youtube.com/embed/ZEjcB0XX0kA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </div>
      <div class="col-md-4 mb-4">
        <div class="ratio ratio-4x3">
          <iframe src="https://www.youtube.com/embed/U7-GvuJW5mg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="localizacao" id="localizacao">
  <div class="ratio mapa">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13555.835353585626!2d-47.714087210715505!3d-21.44575309854946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94b834f769cc0b89%3A0x539ea64e7a08df0d!2sFazenda%20Estrela%20d%20Oeste!5e1!3m2!1spt-BR!2sbr!4v1678221790330!5m2!1spt-BR!2sbr"
      width="600"
      height="450"
      style="border: 0"
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</div>
<footer class="rodape" id="contato">
  <div class="container">
    <div class="row d-flex align-items-center">
      <div class="col-md-4 text-center">
        <img src="./assets/img/logo2.png" alt="Logo" />
      </div>
      <div class="col-md-4 conts text-center mt-5 mt-md-0">
        <h3 class="">{{ texto.contato.titulo }}</h3>
        <p class="">
          <a
            href="tel:1640095108"
            class="d-flex align-items-center justify-content-center gap-2"
            ><i class="fab fa-whatsapp"></i> <span>(16) 4009-5108</span></a
          >
        </p>
        <p>
          <a
            href="mailto:contato@quadrigas.com.br"
            class="d-flex align-items-center justify-content-center gap-2"
            ><i class="far fa-envelope"></i>
            <span>fazenda.estreladoeste2@gmail.com</span></a
          >
        </p>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <h3 class="text-center">{{ texto.contato.localizacao }}</h3>
        <p class="text-center">Fazenda Estrela D'Oeste em São Simão/SP</p>
      </div>
      <div class="copy col-md-4 text-end"></div>
    </div>
  </div>
</footer>
